'use client'
import Link from 'next/link'
import React from 'react'
import NavigateButton from '../NavigateButton'
import ViewAll from '../ViewAll'
import styles from './styles.module.scss'

interface TopBarProps {
  linkAddress: string | null
  title: string
  setPrevSlide?: () => void
  setNextSlide?: () => void
  showNavigationButtons: boolean
  titlePosition?: 'left' | 'center'
  navigationPosition?: 'top' | 'bottom'
  navigationTheme?: 'dark' | 'light'
}

const TopBar: React.FC<TopBarProps> = ({
  title,
  setPrevSlide,
  setNextSlide,
  linkAddress,
  showNavigationButtons,
  titlePosition,
  navigationPosition = 'top',
  navigationTheme = 'light',
}) => {
  return (
    <div className={`${styles.container} ${styles[titlePosition || '']}`}>
      <h2 className={`${styles.title}`}>{title}</h2>
      <div className={styles.buttonWrapper}>
        {linkAddress && navigationPosition === 'top' && (
          <Link href={linkAddress}>
            <ViewAll navigationTheme={navigationTheme} />
          </Link>
        )}

        {showNavigationButtons && (
          <div className={styles.navigationWrapper}>
            <NavigateButton
              direction="prev"
              onClick={() => setPrevSlide && setPrevSlide?.()}
            />
            <NavigateButton
              direction="next"
              onClick={() => setNextSlide && setNextSlide?.()}
            />
          </div>
        )}
      </div>
    </div>
  )
}
export default React.memo(TopBar)
